import React, { memo, useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { createSelector } from 'reselect';
import { logging, logPostInfo } from '../../../actions/log';
import { CONTEXT } from '../../../config';
import { changeClass } from '../../../utils/utils';
import ImgVideo from '../ImgVideo/ImgVideo';
import Button from '../../Button/Button';
import styles from './SoftLine8.module.less';
import _LogInView from '../../_LogInView/_LogInView';
import GameRate from '../GameRate/GameRate';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(({ soft, logInfo }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const logInfoData = useSelector(selectLogInfo);
  const [softDom, setSoftDom] = useState(null);
  const [btnDom, setBtnDom] = useState(null);
  const [infoDom, setInfoDom] = useState(null);
  const [showInfo, setShowInfo] = useState(null);

  const handleSoftCard = useCallback(() => {
    const source = logInfo ? logInfo.source : 'SoftCard_err';
    dispatch(
      logging({
        category: 'C',
        action: 'handle_SoftCard',
        label: '',
        param2: {
          ...logInfo,
          source: logInfo.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
        param3: soft.bizInfo,
      }),
    );
    dispatch(
      logPostInfo({
        source_p: source,
        source_pp: logInfoData.source_p,
      }),
    );
    if (soft.androidType === '1') {
      history.push(
        `${CONTEXT}/adetail/${soft.packageName}/${soft.versionCode}/${soft.bizInfo || '{}'}`,
      );
    } else {
      history.push(`${CONTEXT}/detail/soft/${soft.softID}/${soft.bizInfo || '{}'}`);
    }
  });

  useEffect(() => {
    if (showInfo?.show && infoDom) {
      changeClass(infoDom, styles.mouse_in, styles.mouse_out);
    }
  }, [infoDom, showInfo]);

  const onMouseOver = useCallback(() => {
    // 控制按钮展示
    if (btnDom) {
      changeClass(btnDom, styles.mouse_in, styles.mouse_out);
    }
    // 控制悬浮展示
    if (softDom) {
      let clientRct = softDom.getBoundingClientRect();
      if (!showInfo?.show) {
        const timeoutIndex = setTimeout(() => {
          loggingHover();
        }, 1000);
        setShowInfo({
          show: true,
          timeoutIndex,
          className: window.outerWidth - clientRct.right > 180 ? '' : 'soft_info_box_l',
        });
      }
    }
  }, [softDom, btnDom, infoDom, showInfo]);
  const onMouseLeave = useCallback(() => {
    clearTimeout(showInfo?.timeoutIndex);
    setShowInfo(null);
    if (btnDom) {
      changeClass(btnDom, styles.mouse_out, styles.mouse_in);
    }
    if (infoDom) {
      changeClass(infoDom, styles.mouse_out, styles.mouse_in);
    }
  }, [softDom, btnDom, infoDom, showInfo]);

  const loggingHover = useCallback(() => {
    dispatch(
      logging({
        category: 'C',
        action: `${logInfo.clTag || logInfo.tag}_Content_Hover`,
        label: '',
        param2: {
          ...logInfo,
          source: logInfo.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
        param3: soft.bizInfo,
      }),
    );
  }, []);

  const createSoftTag = useCallback(tags => {
    if (!tags || tags.length === 0) {
      return '';
    }
    let arr = [];
    for (let i = 0; i < tags.length; i++) {
      arr.push(tags[i].name);
    }
    return arr.join(' / ');
  }, []);

  const formatPriceType3 = useCallback((num = '0') => {
    return parseFloat((num || '0')?.replace('¥', '').replace('￥', ''));
  }, []);
  const formatPrice = useCallback((num = '0') => {
    return `${parseFloat((parseInt(num) / 100).toFixed(2)) || 0}`;
  }, []);
  const formatPriceZK = useCallback((cu_, or_) => {
    let cu = parseFloat(cu_);
    let or = parseFloat(or_);
    if (cu && or) {
      return `${parseFloat((cu / or).toFixed(2)) * 10 || 0}`;
    }
    return '';
  }, []);

  return (
    <_LogInView cardData={soft} logInfo={logInfo}>
      <div className={styles.soft_item} ref={r => setSoftDom(r)} onClick={handleSoftCard}>
        <div
          className={`soft_box`}
          onMouseOver={e => onMouseOver(e)}
          onMouseLeave={e => onMouseLeave(e)}
        >
          <div className={`soft_logo`}>
            <img className="soft_logo_img" src={soft?.logoFile} />
            {soft?.androidType === '1' && <div className={`soft_logo_and`}></div>}
            {soft?.androidType !== '1' && soft?.installFileType === 1 && (
              <div className={`soft_logo_dlc`}></div>
            )}
          </div>
          <div className={`soft_name`}>{soft?.softName}</div>
          <div className={`soft_info`}>
            {soft?.androidType === '3' && soft?.sourceInfo && soft?.sourceInfo?.sellInfo && (
              <div className={`soft_price`}>
                {soft?.sourceInfo?.sellInfo?.discount &&
                  soft?.sourceInfo?.sellInfo?.discount != '0' && (
                    <div className={`soft_price_zk`}>
                      <div className={`soft_price_zk_text`}>
                        {soft?.sourceInfo?.sellInfo?.discount} 折
                      </div>
                    </div>
                  )}
                {(soft?.sourceInfo?.sellInfo?.currentPrice ||
                  soft?.sourceInfo?.sellInfo?.originalPrice) && (
                  <div className={`soft_price_n`}>
                    ¥
                    {formatPriceType3(
                      soft?.sourceInfo?.sellInfo?.currentPrice ||
                        soft?.sourceInfo?.sellInfo?.originalPrice,
                    )}
                  </div>
                )}
              </div>
            )}
            {soft?.payType === 1 && (
              <div className={`soft_price`}>
                {soft?.currentPrice &&
                  soft?.originalPrice &&
                  soft?.currentPrice !== soft?.originalPrice && (
                    <div className={`soft_price_zk`}>
                      <div className={`soft_price_zk_text`}>
                        {formatPriceZK(soft?.currentPrice, soft?.originalPrice)} 折
                      </div>
                    </div>
                  )}
                {(soft?.currentPrice || soft?.originalPrice) && (
                  <div className={`soft_price_n`}>
                    ¥{formatPrice(soft?.currentPrice || soft?.originalPrice)}
                  </div>
                )}
              </div>
            )}
            {((soft?.androidType !== '3' && soft?.payType !== 1) ||
              (soft?.androidType === '3' &&
                !soft?.sourceInfo?.sellInfo?.currentPrice &&
                !soft?.sourceInfo?.sellInfo?.originalPrice)) && (
              <div className={`soft_info_text`}>免费</div>
            )}
          </div>
          <div
            className={`soft_btn`}
            ref={r => setBtnDom(r)}
            onClick={e => {
              e.stopPropagation();
              e.preventDefault();
            }}
          >
            <Button
              soft={soft}
              info={{
                btnStyle: logInfo?.tag?.indexOf('Game_') > -1 ? 'black' : '',
                className: styles.soft_button,
                className_busing: styles.soft_button_busing,
                className_open: styles.button_open,
              }}
              logInfo={logInfo}
            />
          </div>
        </div>
        {/* <div className={`soft_info_box ${showInfo?.className}`} ref={r => setInfoDom(r)}> */}

        <div className={`soft_info_box ${showInfo?.className} mouse_in`} ref={r => setInfoDom(r)}>
          {showInfo?.show && (
            <>
              <div className={`soft_info_video_img`}>
                <div className={`soft_infos_video_img_box`}>
                  <ImgVideo soft={soft} styleInfo={{ width: '172px', height: '88px' }} />
                </div>
              </div>
              <div className={`infos`}>
                <div className={`soft_infos_name`}>{soft?.softName}</div>
                <div className={`soft_infos_desc`}>{soft?.introduction}</div>
                <div className={`soft_infos_score`}>
                  <span className="soft_icon iconfont icon-game_s_zan"></span>
                  {parseInt(soft?.scoreRadio || '0') > 70 ? (
                    <span>{soft?.scoreRadio}%好评率</span>
                  ) : (
                    <GameRate
                      score={parseInt(parseInt(soft?.score || 60) / 20)}
                      styleType={`black`}
                    />
                  )}
                </div>
                <div className={`soft_infos_dl`}>
                  <span className="soft_icon iconfont icon-game_s_dl"></span>
                  <span>{`${soft.downloadCount}安装`}</span>
                </div>

                {soft?.relationTags && soft?.relationTags?.length > 0 ? (
                  <div className={`soft_infos_sign`}>
                    <span className="soft_icon iconfont icon-game_s_tag"></span>
                    <span>{createSoftTag(soft?.relationTags)}</span>
                  </div>
                ) : (
                  <div className={`soft_infos_sign`}>
                    <span className="soft_icon iconfont icon-game_s_time"></span>
                    <span>{soft?.createdTime?.split(' ')[0]}更新</span>
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </_LogInView>
  );
});
